// @flow

import * as React from 'react';

import {
  type SideEffect,
  type SideEffectRegistry,
  createSideEffectRegistry,
} from 'app/common/SideEffects';

const { Consumer, Provider } = React.createContext<SideEffectRegistry>(
  createSideEffectRegistry()
);

export { Consumer as SideEffectsConsumer };
export { Provider as SideEffectsProvider };

type RegisterProps = {
  children: React.Node,
  effects: Array<SideEffect>,
  registry: SideEffectRegistry,
};

class SideEffectsRegister extends React.Component<RegisterProps> {
  componentDidMount() {
    this.props.registry.register(...this.props.effects);
  }

  componentDidUpdate(prevProps: RegisterProps) {
    this.props.registry.unregister(...prevProps.effects);
    this.props.registry.register(...this.props.effects);
  }

  componentWillUnmount() {
    this.props.registry.unregister(...this.props.effects);
  }

  render() {
    return this.props.children;
  }
}

type Props = {
  children: React.Node,
  effects: Array<SideEffect>,
};

export const WithSideEffects = (props: Props) => (
  <Consumer>
    {registry => <SideEffectsRegister registry={registry} {...props} />}
  </Consumer>
);
